import { render } from "./Mwp.vue?vue&type=template&id=95a078c8"
import script from "./Mwp.vue?vue&type=script&lang=js"
export * from "./Mwp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\WORKZONE\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__